import { useSelector, useDispatch } from "react-redux"
import { useState } from "react"
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import { GetWorkoutTemplateNameFromKey, GetStrengthSessionPhaseNamesFromPhaseIndex } from "functions/textUtils"
import { removeOverride } from "redux/slices/generator"

export default function OverridesInputContainer() {

    const dispatch = useDispatch()
    
    const overrides = useSelector((state) => state.generator.inputs.overrides)

    const [detailsExpanded, setDetailsExpanded] = useState(false)

    return (
        <div className='bg-white border border-gray-400 p-4 rounded-xl space-y-6'>

            <div 
                className='flex items-center cursor-pointer gap-x-4'
                onClick={() => setDetailsExpanded(!detailsExpanded)}
            >
                <div className='flex-grow'>Overrides</div>
                {!detailsExpanded && <ChevronDownIcon className='w-6 h-6 text-gray-400' />}
                {detailsExpanded && <ChevronUpIcon className='w-6 h-6 text-gray-400' />}
            </div>

            {detailsExpanded && 
                <div className='p-4 space-y-4 bg-gray-100 rounded-lg'>

                    {/* <div 
                        className="text-center rounded-full border border-gray-400 p-2 bg-white cursor-pointer"
                        onClick={() => ShowAddOverrideModal()}
                    >
                        Add New Override
                    </div> */}

                    {overrides.length > 0 &&
                        <div className="grid grid-cols-4 gap-2">
                            {overrides.map((override, overrideIndex) => (
                                <div 
                                    key={overrideIndex}
                                    className='relative border border-gray-400 rounded-xl p-2 space-y-2 bg-white h-48 overflow-y-auto'
                                >
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            dispatch(removeOverride(overrideIndex))
                                        }}
                                        className="absolute top-2 right-2 text-red-600 hover:text-red-800 font-bold"
                                    >
                                        ×
                                    </button>

                                    {override.overrideKey === 'program-phase-slot-exercise-reps-override' &&
                                        <div>
                                            <div>{override.overrideKey}</div>
                                            <div className='font-semibold underline'>Target</div>
                                            <div>{override.programPhaseKey}</div>
                                            <div>{GetWorkoutTemplateNameFromKey(override.target.workoutTemplateKey)}</div>
                                            <div>{GetStrengthSessionPhaseNamesFromPhaseIndex(override.target.phaseIndex)} Lift {override.target.slotIndex + 1}</div>
                                            <div>{override.target.exerciseName}</div>
                                            <div>{override.target.reps} {override.target.lateral === 'unilateral' ? ' reps per side' : 'reps'}</div>
                                        </div>
                                    }
                                    
                                    {override.overrideKey === 'slot-exercise-progression-exercise-removal' &&
                                        <div>
                                            <div>{override.overrideKey}</div>
                                            <div className='font-semibold underline'>Target</div>
                                            <div>{override.target.weekOfTheYearKey}</div>
                                            <div>{GetWorkoutTemplateNameFromKey(override.target.workoutTemplateKey)}</div>
                                            <div>{GetStrengthSessionPhaseNamesFromPhaseIndex(override.target.phaseIndex)} Lift {override.target.slotIndex + 1}</div>
                                            <div>{override.source.exerciseName}</div>
                                        </div>
                                    }
                                    {override.overrideKey === 'one-off-exercise-swap' &&
                                        <div>
                                            <div>{override.overrideKey}</div>
                                            <div className='font-semibold underline'>Target</div>
                                            <div>{override.target.weekOfTheYearKey}</div>
                                            <div>{GetWorkoutTemplateNameFromKey(override.target.workoutTemplateKey)}</div>
                                            <div>{GetStrengthSessionPhaseNamesFromPhaseIndex(override.target.phaseIndex)} Lift {override.target.slotIndex + 1}</div>
                                            <div>{override.target.exerciseName}</div>
                                        </div>
                                    }
                                    {override.overrideKey === 'one-off-sets-override' &&
                                        <div>
                                            <div>{override.overrideKey}</div>
                                            <div className='font-semibold underline'>Target</div>
                                            <div>{override.target.weekOfTheYearKey}</div>
                                            <div>{GetWorkoutTemplateNameFromKey(override.target.workoutTemplateKey)}</div>
                                            <div>{GetStrengthSessionPhaseNamesFromPhaseIndex(override.target.phaseIndex)}</div>
                                            <div>{override.target.sets} sets</div>
                                        </div>
                                    }
                                    {override.overrideKey === 'one-off-reps-override' &&
                                        <div>
                                            <div>{override.overrideKey}</div>
                                            <div className='font-semibold underline'>Target</div>
                                            <div>{override.target.weekOfTheYearKey}</div>
                                            <div>{GetWorkoutTemplateNameFromKey(override.target.workoutTemplateKey)}</div>
                                            <div>{GetStrengthSessionPhaseNamesFromPhaseIndex(override.target.phaseIndex)} Lift {override.target.slotIndex + 1}</div>
                                            <div>{override.target.reps} reps</div>
                                        </div>
                                    }
                                    {override.overrideKey === 'one-off-weight-recommendation-override' &&
                                        <div>
                                            <div>{override.overrideKey}</div>
                                            <div className='font-semibold underline'>Target</div>
                                            <div>{override.target.weekOfTheYearKey}</div>
                                            <div>{GetWorkoutTemplateNameFromKey(override.target.workoutTemplateKey)}</div>
                                            <div>{GetStrengthSessionPhaseNamesFromPhaseIndex(override.target.phaseIndex)} Lift {override.target.slotIndex + 1}</div>
                                            <div>{override.target.weightRecommendation} lbs</div>
                                        </div>
                                    }
                                    {override.overrideKey === 'phase-load-adjustment-override' &&
                                        <div>
                                            <div>{override.overrideKey}</div>
                                            <div className='font-semibold underline'>Target</div>
                                            <div>{override.target.weekOfTheYearKey}</div>
                                            <div>{GetWorkoutTemplateNameFromKey(override.target.workoutTemplateKey)}</div>
                                            <div>{GetStrengthSessionPhaseNamesFromPhaseIndex(override.target.phaseIndex)}</div>
                                            <div>{override.target.loadAdjustment.adjustmentType}: {override.target.loadAdjustment.adjustmentValue}</div>
                                        </div>
                                    }            
                                </div>
                            ))}
                        </div>
                    }

                </div>
            }

        </div>
    )

}